import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { setLanguage } from '../../store/settings.actions';
import { LanguageService } from 'src/app/config/language.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnInit {
  currentLanguage: string = '';
  languageMapping: {
    [key: string]: string;
  } = {
    en: 'en_US',
    fr: 'fr_FR',
    it: 'it_IT',
  };

  id: number | null = null;
  constructor(
    private translateService: TranslateService,
    private readonly store: Store,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.currentLanguage = this.languageService.getCurrentLanguage();
  }
  switchLanguage(lang: string) {
    if (lang === this.translateService.currentLang) {
      return ;
    }
    localStorage.setItem('lang', lang);
    this.currentLanguage = lang;
    this.languageService.changeLanguage(lang);
  }
  close() {
    history.back();
  }
}
